export const rxNumberFixLength = (length) => {
  const regexStr = `/^[0-9]${length}+$/`;

  return new RegExp(regexStr);
};
// export const rxNumber10 = new RegExp(/^\d{1,10}$/);
export const rxNumber17 = new RegExp(/^[a-zA-Z0-9]{17}/);
export const rxNumber13 = new RegExp(/^[a-zA-Z0-9]{13}/);
export const rxNumber20 = new RegExp(/^[a-zA-Z0-9]{1,20}$/);
export const rxNumber = new RegExp(/^[0-9]+$/);
export const rxPhoneNumber = new RegExp(/^[0-9\-\+]{8,15}$/);
export const rxPhoneNumber8to11 = new RegExp(/^[0-9\-\+]{8,11}$/);
export const rxSpecialChar = new RegExp(/[`!@#$%^&*()_+=\[\]{}':"\\|<>?~-]/);
export const rxSpecialCharVietnamese = new RegExp(/^[a-zA-Z0-9 ]*$/);
export const rxSpecialCharNotDot = new RegExp(
  /^[a-zA-Z0-9`!@#$%^&*() _+=\/[\]{}'.,:;"\\|<>?~-]+$/
);

export const rxSpecialCharNotSpace = new RegExp(/^\S+$/);
export const rxSpecialCharChannelName = new RegExp(
  /[`,.!@#$%^&*()_+=\[\]{}':"\\|<>?~-]/
);
export const rxSpecialCharAccountName = new RegExp(
  /[`,.!@#$%^&*()+=\[\]{}':"\\|<>?~-]/
);
export const rxNumberDotAndCommas = new RegExp(/^-?(\d+(?:[\.\,]\d{1,99})?)$/);
export const rxNumberDot = new RegExp(/^-?(\d+(?:[\.]\d{1,99})?)$/);
export const rxEmail = new RegExp(
  /^[a-zA-Z0-9!#$%&'*+=?^_`{|}.~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
);
export const rxPositiveNumber = new RegExp(/^[1-9]\d*$/);
export const rxIP = new RegExp(
  /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
);
export const rxPassword = new RegExp(
  // /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!~@#$%^&+=?.,<>[\]:;'"{}`])(?!.*\s).{8,}$/
  /^(?=.*[a-z])(?=.*\d)[a-zA-Z\d!~@#$|%^&+=?.,<>[\]-_*():;'"{}`]{8,}$/
);
export const rxCharNotNumberAndSpecial = new RegExp(
  /^[^\d~!@#$%^&*()-_+={}[\]\\|:;‘“<>,.?]*[a-zA-ZÀ-Ỹà-ỹĂăÂâĐđÊêÔôƠơƯưỨứỪừỬửỰựỬừỨứÊêÔôƠơƯưỪừỬửỰựỞởỎỏỌọỊịỤụẨẩẦầẤấẪẫẬậẮắẰằẲẳẶặẴẵỀềỂểỄễẾếỆệẸẹỈỉỊịỎỏỐốỒồỔổỖỗỘộỚớỜờỞởỠỡỢợỤụỨứỪừỬửỰựỨứỪừỬửỰựỞởỎỏỌọỊịỤụẨẩẦầẤấẪẫẬậẮắẰằẲẳẶặẴẵỀềỂểỄễẾếỆệẸẹỈỉỊịỎỏỐốỒồỔổỖỗỘộỚớỜờỞởỠỡỢợỤụỨứỪừỬửỰựỨứỪừỬửỰựỞởỎỏỌọỊịỤụẨẩẦầẤấẪẫẬậẮắẰằẲẳẶặẴẵỀềỂểỄễẾếỆệẸẹỈỉỊịỎỏỐốỒồỔổỖỗỘộỚớỜờỞởỠỡỢợỤụ ]+\s*[^\d~!@#$%^&*()-_+={}[\]\\|:;‘“<>,.?]*$/
);

/**
 * - Include special characters / number / a - z /
 * - Not include vietnamese / space /
 */
export const rxSpecialCharNotSpaceAndVietnamese = new RegExp(
  /^[0-9a-zA-Z`!@#$%^&*()_+=\/[\]{}'.,:;"\\|<>?~-]+$/
);

export const rxChannelName = new RegExp(
  /^[a-zA-Z0-9!`~@#$%^&+=?.,<>\[\]:;'"\/\|{}\s]*$/
);
export const rxFileName = new RegExp(/^[a-zA-Z0-9,.\/\\-_-\ ]*$/);

export const rxPaperIdNumber = new RegExp(
  /^[0-9a-zA-Z`!@#$%^&*()_+=\/[\]{}'.,:;"\\|<>?~-]*$/
);

/**
 * @function rxOnlyNumberAndLetter
 * CHECK REGEX:::
 * - Include / number / a - z
 */
export const rxOnlyNumberAndLetter = new RegExp(/^[a-zA-Z0-9]*$/);

/**
 * @function rxContent
 * CHECK REGEX:::
 * - Include / number / a - z / space
 * - Not include vietnamese /
 */
export const rxContent = new RegExp(/^[a-zA-Z0-9.,\-\_/ ]*$/);

export const rxDocumentNo = new RegExp(
  /^[a-zA-Z0-9` !@#$%^&*()_+=\/[\]{}'.,:;"\\|<>?~-]*$/
);

/**
 * @function rxNotSpaceAndVietnamese
 * CHECK REGEX:::
 * - Include special characters / number / a - z /
 * - Not include vietnamese / space /
 */
export const rxNotSpaceAndVietnamese = new RegExp(
  /^[0-9a-zA-Z`!@#$%^&*()_+=\/[\]{}'.,:;"\\|<>?~-]*$/
);

/**
 * @function rxNotVietnamese
 * CHECK REGEX:::
 * - Include special characters / number / a - z / space /
 * - Not include vietnamese
 */
export const rxNotVietnamese = new RegExp(
  /^[0-9a-zA-Z`!@#$%^&*()_+=\/[\]{ }'.,:;"\\|<>?~-]*$/
);
